<form [formGroup]="form" (ngSubmit)="submitForm()" #formContainer>
    <div class="inp-field">
        <label
            >{{ selectedLanguage === "en" ? content.name : content.nameBm
            }}<span class="tw-text-red-400 tw-ml-[5px]">*</span></label
        >
        <input
            type="text"
            [placeholder]="
                selectedLanguage === 'en' ? content.name : content.nameBm
            "
            formControlName="name"
            [ngClass]="{
                'input-error':
                    form.get('name')?.touched && form.get('name')?.invalid
            }"
        />
        <div
            class="error"
            *ngIf="form.get('name')?.touched && form.get('name')?.invalid"
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{ selectedLanguage === "en" ? errors.name : errors.nameBm }}
        </div>
    </div>

    <div class="inp-field">
        <label
            >{{ selectedLanguage === "en" ? content.email : content.emailBm
            }}<span class="tw-text-red-400 tw-ml-[5px]">*</span></label
        >
        <input
            type="email"
            [placeholder]="
                selectedLanguage === 'en' ? content.email : content.emailBm
            "
            formControlName="email"
            [ngClass]="{
                'input-error':
                    form.get('email')?.touched && form.get('email')?.invalid
            }"
        />
        <div
            class="error"
            *ngIf="form.get('email')?.touched && form.get('email')?.invalid"
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{ selectedLanguage === "en" ? errors.email : errors.emailBm }}
        </div>
    </div>

    <div class="inp-field">
        <label
            >{{ selectedLanguage === "en" ? content.phone : content.phoneBm
            }}<span class="tw-text-red-400 tw-ml-[5px]">*</span></label
        >
        <input
            type="text"
            [placeholder]="
                selectedLanguage === 'en' ? content.phone : content.phoneBm
            "
            formControlName="phoneNumber"
            [ngClass]="{
                'input-error':
                    form.get('phoneNumber')?.touched &&
                    form.get('phoneNumber')?.invalid
            }"
        />
        <div
            class="error"
            *ngIf="
                form.get('phoneNumber')?.touched &&
                form.get('phoneNumber')?.invalid
            "
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{ selectedLanguage === "en" ? errors.phone : errors.phoneBm }}
        </div>
    </div>

    <div class="inp-field">
        <label>
            {{
                selectedLanguage === "en"
                    ? "Property occupied as"
                    : "Hartanah yang diduduki sebagai"
            }}<span class="tw-text-red-400 tw-ml-[5px]">*</span>
        </label>

        <div
            class="custom-select-box"
            tabindex="0"
            (click)="toggleDropdown()"
            [ngClass]="{
                'dropdown-error':
                    form.get('natureOfBusiness')?.touched &&
                    form.get('natureOfBusiness')?.invalid
            }"
        >
            <div
                class="selected-option"
                [ngClass]="selectedValue && '!tw-text-black'"
            >
                {{
                    (selectedLanguage == "en"
                        ? selectedValue?.en
                        : selectedValue?.bm) ||
                        (selectedLanguage === "en"
                            ? "Select Business Type"
                            : "Pilih Jenis Perniagaan")
                }}

                <mat-icon
                    aria-label="home icon "
                    class="tw-relative !tw-text-black !tw-h-[16px]"
                    [ngClass]="
                        selectedValue == null
                            ? dropdownOpen
                                ? 'tw-rotate-180 tw-top-1'
                                : 'tw-top-1'
                            : dropdownOpen
                            ? 'tw-rotate-180 -tw-top-1.5'
                            : '-tw-top-1.5'
                    "
                >
                    {{
                        dropdownOpen
                            ? "keyboard_arrow_up"
                            : "keyboard_arrow_down"
                    }}
                </mat-icon>
            </div>
            <div *ngIf="dropdownOpen" class="dropdown-options">
                <div
                    *ngFor="let item of content.natureOfBusinessOptions"
                    (click)="selectOption(item, $event)"
                    class="dropdown-item"
                >
                    {{ selectedLanguage === "en" ? item.en : item.bm }}
                </div>
            </div>
        </div>
        <div
            class="error"
            *ngIf="
                form.get('natureOfBusiness')?.touched &&
                form.get('natureOfBusiness')?.invalid
            "
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{
                selectedLanguage === "en"
                    ? errors.natureOfBusiness
                    : errors.natureOfBusinessBm
            }}
        </div>
    </div>

    <div class="inp-field">
        <label
            >{{ selectedLanguage === "en" ? content.company : content.companyBm
            }}<span class="tw-text-red-400 tw-ml-[5px]">*</span></label
        >
        <input
            type="text"
            [placeholder]="
                selectedLanguage === 'en' ? content.company : content.companyBm
            "
            formControlName="companyName"
            [ngClass]="{
                'input-error':
                    form.get('companyName')?.touched &&
                    form.get('companyName')?.invalid
            }"
        />
        <div
            class="error"
            *ngIf="
                form.get('companyName')?.touched &&
                form.get('companyName')?.invalid
            "
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{ selectedLanguage === "en" ? errors.company : errors.companyBm }}
        </div>
    </div>

    <div class="inp-field">
        <label>{{
            selectedLanguage === "en" ? content.brn : content.brnBm
        }}</label>
        <input
            type="text"
            [placeholder]="
                selectedLanguage === 'en' ? content.brn : content.brnBm
            "
            formControlName="businessRegistrationNumber"
            [ngClass]="{
                'input-error':
                    form.get('businessRegistrationNumber')?.touched &&
                    form.get('businessRegistrationNumber')?.invalid
            }"
        />
        <div
            class="error"
            *ngIf="
                form.get('businessRegistrationNumber')?.touched &&
                form.get('businessRegistrationNumber')?.invalid
            "
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{ selectedLanguage === "en" ? errors.brn : errors.brnBm }}
        </div>
    </div>

    <div class="inp-field">
        <label class="tw-mb-[15px]">
            {{
                selectedLanguage === "en"
                    ? content.insuranceType
                    : content.insuranceTypeBm
            }}
            <span class="tw-text-red-400 tw-ml-[5px]">*</span>
        </label>

        <div
            class="tw-grid lg:tw-grid-cols-2 tw-gap-[10px]"
            [ngClass]="{
                'checkbox-invalid':
                    form.get('typeOfInsurance')?.touched &&
                    form.get('typeOfInsurance')?.invalid
            }"
        >
            <div
                class="tw-text-[#7B7575]"
                *ngFor="let item of content.insuranceOptions; let i = index"
            >
                <label
                    class="tw-cursor-pointer !tw-text-[15px] custom-checkbox"
                    [for]="i"
                >
                    <input
                        [id]="i"
                        type="checkbox"
                        [value]="item.en"
                        (change)="onCheckboxChange($event)"
                    />
                    <span class="checkmark"></span>
                    {{ selectedLanguage == "en" ? item.en : item.bm }}
                </label>
            </div>
        </div>
        <div
            class="error !tw-ml-0"
            *ngIf="
                form.get('typeOfInsurance')?.touched &&
                form.get('typeOfInsurance')?.invalid
            "
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{
                selectedLanguage === "en"
                    ? errors.insuranceType
                    : errors.insuranceTypeBm
            }}
        </div>
    </div>

    <div>
        <div class="tw-flex tw-gap-[5px] tw-items-start">
            <input
                class="tw-mt-[3px]"
                type="checkbox"
                formControlName="termsConditions"
            />
            <span
                class="tw-text-[14px] tw-text-[#7B7575]"
                [innerHTML]="
                    selectedLanguage === 'en' ? content.terms : content.termsBm
                "
                ><span class="tw-text-red-400 tw-ml-[5px]">*</span></span
            >
        </div>
        <div
            class="error !tw-ml-[15px] !tw-mt-[7px]"
            *ngIf="
                form.get('termsConditions')?.touched &&
                form.get('termsConditions')?.invalid
            "
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{ selectedLanguage === "en" ? errors.terms : errors.termsBm }}
        </div>
    </div>

    <button
        ga-event-id="bizcare_submit_button_insurance_click"
        ga-event-category="Insurance Details Page Button"
        ga-event-label="Submit Button Click"
        ga-track="track"
        class="disabled:tw-opacity-70 tw-bg-[#FFA53C] tw-text-white tw-rounded-full md:tw-max-w-fit tw-px-[100px] tw-py-[13px]"
        type="submit"
    >
        {{ selectedLanguage === "en" ? "Submit" : "Hantar" }} >
    </button>
</form>
